import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	PetitionReadyToSharePostsByPlatformQuery,
	PetitionReadyToSharePostsByPlatformQueryVariables,
} from './getPetitionReadyToSharePostsByPlatform.graphql';
import { PetitionReadyToSharePostsByPlatform } from './getPetitionReadyToSharePostsByPlatform.graphql';

export * from './getPetitionReadyToSharePostsByPlatform.graphql';

// Extract the success type from the union
type PetitionResult = PetitionReadyToSharePostsByPlatformQuery['petitionBySlugOrId'];
type ReadyToSharePostsResult = NonNullable<PetitionResult>['readyToSharePosts'];

type ReadyToSharePostsSuccess = Extract<ReadyToSharePostsResult, { __typename: 'ReadyToSharePostsSuccess' }>;

// Extract the post item type from the generated query for reuse across components
export type ReadyToSharePostWithPlatform = NonNullable<ReadyToSharePostsSuccess['items'][number]>;

export async function getPetitionReadyToSharePostsByPlatform(
	variables: PetitionReadyToSharePostsByPlatformQueryVariables,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionReadyToSharePostsByPlatformQuery | null> {
	const { data } = await fetch<
		PetitionReadyToSharePostsByPlatformQuery,
		PetitionReadyToSharePostsByPlatformQueryVariables
	>({
		query: PetitionReadyToSharePostsByPlatform,
		variables,
		rejectOnError: false,
	});

	return data ?? null;
}
